import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { Col } from 'react-styled-flexboxgrid';
import { Input as CheckboxInput } from './CheckboxInput';
import { Input as DateInput } from './DateInput';
import { Input as PrivateInput } from './PrivateInput';
import { Input as SelectInput } from './SelectInput';
import { SeparatorBuilder } from './SeparatorBuilder';
import { Input as TextInput } from './TextInput';
import { Input as TextareaInput } from './TextareaInput';
var inputMap = {
  checkbox: CheckboxInput,
  date: DateInput,
  number: TextInput,
  "private": PrivateInput,
  password: PrivateInput,
  select: SelectInput,
  separator: SeparatorBuilder,
  tel: TextInput,
  text: TextInput,
  textarea: TextareaInput
};

var FormItem = function FormItem(_ref) {
  var type = _ref.type,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? {} : _ref$sizes,
      props = _objectWithoutProperties(_ref, ["type", "sizes"]);

  var Component = typeof type === 'string' ? inputMap[type] : type;
  var _sizes$md = sizes.md,
      md = _sizes$md === void 0 ? 6 : _sizes$md,
      _sizes$sm = sizes.sm,
      sm = _sizes$sm === void 0 ? 12 : _sizes$sm,
      _sizes$xs = sizes.xs,
      xs = _sizes$xs === void 0 ? 12 : _sizes$xs;
  var altType = ['text', 'number', 'password', 'tel'].includes(type) ? type : null;
  return /*#__PURE__*/React.createElement(Col, {
    md: md,
    sm: sm,
    xs: xs
  }, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    type: altType
  })));
};

export { FormItem };